import { I as Input, d as defineCustomElement$1 } from './input.js';

const WuiInput = Input;
const defineCustomElement = defineCustomElement$1;

export { WuiInput, defineCustomElement };

//# sourceMappingURL=wui-input.js.map